@if (showContextMenu) {
  <cx-context-menu [value]="dataObject" [options]="shapeOptions"/>
  <ng-container *ngTemplateOutlet="elementTemplate" />
} @else {
  <div
    class="full-height full-width shape"
    (contextmenu)="contextMenuComponent ? open($event): null"
  >
    <div class="image-wrapper">
      <img [src]="imageSrc" alt="image">
    </div>
  </div>
}

<ng-template #elementTemplate>
  <div
    class="full-height full-width shape"
    (contextmenu)="contextMenuComponent ? open($event): null"
  >
    <div class="image-wrapper">
      <img [src]="imageSrc" alt="image">
    </div>
  </div>
</ng-template>

<cx-context-submenu #alignSubmenu [options]="alignSubmenuOptions"/>
